import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

var firebaseConfig = {
    apiKey: "AIzaSyClsQ4aBDuqUryP8Hxpu7pvU2e0tFYrU4c",
    authDomain: "kiosk-40705.firebaseapp.com",
    projectId: "kiosk-40705",
    storageBucket: "kiosk-40705.appspot.com",
    messagingSenderId: "520225844726",
    appId: "1:520225844726:web:ef0b03d2fc6cafa7f26bd7",
    measurementId: "G-K6CZ2XSQLP"
};

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
const messaging = getMessaging(firebaseApp);

export const fetchToken = (setFcmToken) => {
    return getToken(messaging, { vapidKey: 'BOU52zYfmKcktGrzT7jW9-5Xb8a97_NBYUHqiCmOLHL8HopX1rbgfCuEQjqyAsvnvZse0SSdV_5rdQaF2AxLwdM' }).then((currentToken) => {
        if (currentToken) {
            setFcmToken(currentToken);
            // Track the token -> client mapping, by sending to backend server
            // show on the UI that permission is secured
        } else {
            setFcmToken(null);
            // shows on the UI that permission is required 
        }
    }).catch((err) => {
        setFcmToken(null);
        // catch error while creating client token
    });
}

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });